import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-primary-red hover:text-primary-red-dark mb-8 transition-colors"
        >
          <ArrowLeft className="mr-2" size={20} />
          Retour à l'accueil
        </Link>

        <article className="prose prose-lg max-w-none">
          <div className="flex items-center space-x-3 mb-6">
            <FileText className="text-primary-red" size={32} />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-0">
              Conditions générales d'utilisation
            </h1>
          </div>

          <div className="text-sm text-gray-500 mb-8">
            Dernière mise à jour : 26 novembre 2025
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              Les présentes conditions générales d'utilisation (ci-après "CGU") régissent l'utilisation 
              du site web parisparihub.com (ci-après "le Site") exploité par ParisPari Hub. En accédant 
              et en utilisant ce Site, vous acceptez d'être lié par ces CGU. Si vous n'acceptez pas 
              ces conditions, veuillez ne pas utiliser le Site.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              1. Acceptation des conditions
            </h2>

            <p>
              En accédant au Site, vous reconnaissez avoir lu, compris et accepté d'être lié par ces 
              CGU ainsi que par notre Politique de confidentialité. Si vous n'acceptez pas ces conditions, 
              vous devez immédiatement cesser d'utiliser le Site.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              2. Description du service
            </h2>

            <p>
              ParisPari Hub est un site d'information, de comparaison et d'analyse des sites de paris 
              en ligne en France. Nous fournissons :
            </p>

            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Des informations sur les sites de paris en ligne agréés en France</li>
              <li>Des comparaisons et analyses de ces sites</li>
              <li>Des guides et actualités sur les paris en ligne</li>
              <li>Des liens d'affiliation vers des sites de paris partenaires</li>
            </ul>

            <p>
              Nous ne sommes pas un opérateur de paris en ligne. Nous ne proposons pas de services de 
              paris directement. Tous les paris sont effectués sur les sites de nos partenaires, qui 
              ont leurs propres conditions générales.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              3. Liens d'affiliation
            </h2>

            <p>
              Notre Site contient des liens d'affiliation vers des sites de paris en ligne. Si vous 
              cliquez sur ces liens et vous inscrivez sur un site partenaire, nous pouvons recevoir 
              une commission. Cette commission n'influence jamais nos opinions, nos analyses ou nos 
              évaluations. Nous restons indépendants et objectifs dans nos recommandations.
            </p>

            <p>
              Lorsque vous cliquez sur un lien d'affiliation, vous quittez notre Site et vous êtes 
              soumis aux conditions générales et à la politique de confidentialité du site partenaire. 
              Nous ne sommes pas responsables des pratiques, du contenu ou des services des sites tiers.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              4. Utilisation du Site
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Utilisation autorisée
            </h3>
            <p>
              Vous pouvez utiliser le Site pour :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Consulter les informations et analyses que nous fournissons</li>
              <li>Comparer les sites de paris en ligne</li>
              <li>Accéder à nos guides et actualités</li>
              <li>Nous contacter via notre formulaire de contact</li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Utilisation interdite
            </h3>
            <p>
              Il est strictement interdit de :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Utiliser le Site à des fins illégales ou non autorisées</li>
              <li>Reproduire, copier, vendre ou exploiter commercialement le contenu du Site sans autorisation</li>
              <li>Tenter d'accéder de manière non autorisée à nos systèmes ou réseaux</li>
              <li>Utiliser des robots, scripts ou autres moyens automatisés pour accéder au Site</li>
              <li>Transmettre des virus, codes malveillants ou tout autre élément nuisible</li>
              <li>Harceler, menacer ou nuire à d'autres utilisateurs</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              5. Propriété intellectuelle
            </h2>

            <p>
              Tout le contenu du Site, incluant mais sans s'y limiter : textes, graphiques, logos, icônes, 
              images, clips audio, téléchargements numériques, et compilations de données, est la propriété 
              de ParisPari Hub ou de ses fournisseurs de contenu et est protégé par les lois françaises 
              et internationales sur le droit d'auteur.
            </p>

            <p>
              Vous ne pouvez pas reproduire, distribuer, modifier, créer des œuvres dérivées, afficher 
              publiquement, exécuter publiquement, republier, télécharger, stocker ou transmettre tout 
              contenu de notre Site sans notre autorisation écrite préalable.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              6. Exactitude des informations
            </h2>

            <p>
              Nous nous efforçons de fournir des informations exactes et à jour sur le Site. Cependant, 
              nous ne garantissons pas l'exactitude, l'exhaustivité ou l'actualité de toutes les informations. 
              Les informations sont fournies "en l'état" sans garantie d'aucune sorte.
            </p>

            <p>
              Les informations sur les sites de paris partenaires, incluant les bonus, les promotions, 
              et les conditions, peuvent changer sans préavis. Nous vous encourageons à vérifier directement 
              sur les sites partenaires les informations les plus récentes avant de prendre une décision.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              7. Limitation de responsabilité
            </h2>

            <p>
              Dans les limites permises par la loi, ParisPari Hub ne sera pas responsable de :
            </p>

            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Les dommages directs, indirects, accessoires, spéciaux ou consécutifs résultant de l'utilisation ou de l'impossibilité d'utiliser le Site</li>
              <li>Les pertes de profits, de données ou d'autres pertes intangibles</li>
              <li>Les actions ou omissions des sites de paris partenaires</li>
              <li>Les erreurs, omissions ou inexactitudes dans le contenu</li>
              <li>Les interruptions de service ou problèmes techniques</li>
            </ul>

            <p>
              Notre responsabilité totale envers vous pour toutes les réclamations liées à l'utilisation 
              du Site ne dépassera pas le montant que vous avez payé pour accéder au Site (qui est actuellement 
              gratuit).
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              8. Sites tiers
            </h2>

            <p>
              Le Site contient des liens vers des sites web tiers, incluant des sites de paris en ligne. 
              Ces liens sont fournis uniquement pour votre commodité. Nous n'avons aucun contrôle sur 
              le contenu de ces sites et n'assumons aucune responsabilité pour eux.
            </p>

            <p>
              L'inclusion de liens vers des sites tiers ne constitue pas une approbation de ces sites 
              ou de leur contenu. Vous accédez à ces sites à vos propres risques.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              9. Modifications du Site
            </h2>

            <p>
              Nous nous réservons le droit de modifier, suspendre ou interrompre tout ou partie du Site 
              à tout moment, avec ou sans préavis. Nous ne serons pas responsables envers vous ou tout 
              tiers de toute modification, suspension ou interruption du Site.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              10. Modifications des CGU
            </h2>

            <p>
              Nous nous réservons le droit de modifier ces CGU à tout moment. Toute modification sera 
              publiée sur cette page avec une date de mise à jour révisée. Votre utilisation continue 
              du Site après la publication des modifications constitue votre acceptation des nouvelles 
              conditions.
            </p>

            <p>
              Nous vous encourageons à consulter régulièrement cette page pour rester informé des 
              conditions d'utilisation.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              11. Droit applicable et juridiction
            </h2>

            <p>
              Ces CGU sont régies par les lois françaises. Tout litige relatif à ces CGU ou à l'utilisation 
              du Site sera soumis à la juridiction exclusive des tribunaux français.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              12. Contact
            </h2>

            <p>
              Pour toute question concernant ces CGU, contactez-nous :
            </p>

            <div className="bg-gray-50 rounded-lg p-6 mt-4">
              <p className="font-semibold text-gray-900">ParisPari Hub</p>
              <p className="text-gray-700">Email : <a href="mailto:info@parisparihub.com" className="text-primary-red hover:underline">info@parisparihub.com</a></p>
              <p className="text-gray-700">Téléphone : <a href="tel:+33412407011" className="text-primary-red hover:underline">+33 4 12 40 70 11</a></p>
              <p className="text-gray-700">Adresse : Paris, France</p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;

